// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"e6768796","77":"1096e3c8","136":"1347f2ea","371":"a4ceddcb","580":"7a83a9d1","785":"903096d6"}[chunkId] + ".chunk.js";
};